import Vue from "vue";
import Router from "vue-router";
import backorderCustList from "./components/backorders/backorderCustList.vue";
import LoginPage from "./components/login/login.vue";
import NewUser from "./components/login/new-user.vue";
import ApproveUsers from "./components/admin/approveUsers.vue";
import BulkUpdteLiability from "./components/master-liability/bulkUpdteLiability.vue";
import MasterLiabilityChart1 from "./components/master-liability/master-liability-table1.vue";
import EditLog from "./components/master-liability/editLog.vue";
import PlanningAllocation from "./components/planning-allocation/planning-allocation.vue"
import bundle from "./components/bundle/bundle.vue"


Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      alias: "/login",
      component: LoginPage
    },
    {
      path: "/new-user",
      name: "NewUser",
      component: NewUser
    },
    {
      path: "/approve-user",
      name: "ApproveUsers",
      component: ApproveUsers
    },
    {
      path: "/backorderCustList",
      name: "backorderCustList",
      alias: "/backorderCustList",
      component: backorderCustList
    },
    {
      path: "/master-liability-chart",
      name: "MasterLiabilityChart",
      component: MasterLiabilityChart1
    },
    {
      path: "/bulk-update-liability",
      name: "BulkUpdteLiability",
      props: true,
      component: BulkUpdteLiability
    },
    {
      path: "/editLog",
      name: "EditLog",
      props: true,
      component: EditLog
    },
    {
      path: "/planning-allocation",
      name: "PlanningAllocation",
      props: true,
      component: PlanningAllocation
    },
    {
      path: "/bundle",
      name: "Bundle",
      component: bundle
    }
  ]
});
